import { FormControl } from '@angular/forms';

export function inputTooHigh(max: number) {
  return (control: FormControl) => {
    if (control.value > max) {
      return { inputTooLarge: true };
    }

    return null;
  };
}
